export const authMixin = {
  computed: {
    currentRoute: function () {
      const { path, query } = this.$route
      if (query.next) {
        return query.next
      } else {
        return path
      }
    }
  },
  methods: {
    socialLogin: function (provider, next = `/`) {
      console.log(`provider: `, provider)
      const providerCapital = provider.replace(/\b\w/g, function (l) { return l.toUpperCase() })
      this.$auth.authenticate(provider)
        .then(async (response) => {
          console.log(`resp_provider: `, response)
          await this.$store.dispatch(`setTokenFromSocial`, response)
          heap.track(`SI_${providerCapital}_Succeed`)
          console.log(`social Done: `)
          window.location = next
        }).catch(function (error) {
          console.log(`resp_provider_err: `, error)
          heap.track(`SI_${providerCapital}_Failed`)
          console.log(`social error:`, error)
        })
    }
  }
}
